import "src/sns_analysis/application.js";
